import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { DashboardType } from '../types/DatadogDashboardEntity';
import { DatadogDashboardApi } from './DatadogDashboardApi';
import { ResponseError } from '@backstage/errors';

export class DatadogDashboardClient implements DatadogDashboardApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor({
    discoveryApi,
    fetchApi,
  }: {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
    baseUrl?: string;
  }) {
    this.discoveryApi = discoveryApi;
    this.fetchApi = fetchApi;
  }

  getEmbedGraph(query: string) {
    console.log(query)
    throw new Error('Method not implemented.');
  }

  private async callApi<T>(
    path: string,
    method: string,
    body?: BodyInit | null | undefined,
  ): Promise<T | undefined> {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const proxyUri = `${await this.discoveryApi.getBaseUrl('proxy')}/datadog/api`;
    console.log("API URL: ", proxyUri)
    const requestOptions: RequestInit = {
      method: method,
      headers: myHeaders,
      body: body ?? null,
      redirect: 'follow',
    };

    const response = await this.fetchApi.fetch(`${proxyUri}${path}`, requestOptions);
    
    if (response.status === 200) {
      return (await response.json()) as T;
    }
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    } else {
      return undefined;
    }
  }

  async getDataDogDashboard(dashboardId: string): Promise<DashboardType | undefined> {
    const widgetsDatadogDashboard = await this.callApi<DashboardType>(
      `/dashboard/${dashboardId}`,
      'GET',
    );
    return widgetsDatadogDashboard;
  }
}
